<div class="inner-content">
  <div class="cargar-recibo-container" [formGroup]="reciboForm">
    <div class="close-button" (click)="dismiss()" *ngIf="canClose">
      <i class="ri-close-line"></i>
    </div>
    <div class="header">
      <div class="headline-medium">Cargar recibo de pago.</div>
      <yalo-divider size="1"></yalo-divider>
    </div>
    <div class="content">
      <div class="body-large instructions">Completa los datos del pago.</div>
      <div class="one-column">
        <yalo-select ngDefaultControl formControlName="Banco" placeholder="Banco">
          <option *ngFor="let data of bancos" [attr.data-image]="data.ImagenBanco" [value]="data.Id">{{data.NombreBanco}}</option>
        </yalo-select>
      </div>
      <div class="two-columns">
        <yalo-radiobutton
          button
          buttonText="HNL - {{ reciboForm.get('CuentaLempiras').value }}"
          name="accountNumber"
          justify="start"
          (change)="account = 'Lempiras'"></yalo-radiobutton>
        <yalo-radiobutton
          button
          buttonText="USD - {{ reciboForm.get('CuentaDolares').value }}"
          name="accountNumber"
          justify="start"
          (change)="account = 'Dolares'"></yalo-radiobutton>
        <yalo-input
          ngDefaultControl
          formControlName="NumReferencia"
          formError
          type="string"
          isNumber="true"
          placeholder="Número de referencia">
        </yalo-input>
        <yalo-datepicker
          placeholder="Fecha de pago"
          placement="auto"
          (onChange)="onChangeDate($event)">
        </yalo-datepicker>
      </div>
      <div class="three-columns">
        <yalo-divider size="1"></yalo-divider>
        <div class="body-medium">
          o si tienes el recibo de pago puedes subirlo
        </div>
        <yalo-divider size="1"></yalo-divider>
      </div>
    </div>
    <div class="image">
      <app-crop-recibo [hasError]="imageError"></app-crop-recibo>
    </div>
    <div class="footer">
      <div class="body-medium">
        Si no tienes la información bancaria
        <span class="bodylink-medium" (click)="downloadInstructions()">descárgala aqui</span>
      </div>
      <div class="change-method" (click)="goToMethods()">
        <span class="body-medium">Cambiar método de pago</span>
        <i class="ri-arrow-right-s-line"></i>
      </div>
    </div>
    <div class="button">
      <yalo-button
        type="primary"
        text="medium"
        [disabled]="!reciboForm.valid"
        (click)="sendData()">Cargar y continuar</yalo-button>
    </div>
  </div>
</div>